import Vue from 'vue';
import ComplexService from '@/services/complex';

import { FETCH_ALL, REMOVE, SAVE } from '../actions.types';
import {
  SET_ERROR,
  SET_ITEMS,
  SET_ITEM,
  SET_FILTERS,
  REMOVE_ITEM
} from '../mutations.types';

export default {
  namespaced: true,
  state: {
    error: null,
    items: [],
    pagination: {},
    filters: {
      page: 1,
      sort: 'created_at',
      reverse: true
    }
  },
  actions: {
    async [FETCH_ALL]({ commit, state }) {
      try {
        const response = await ComplexService.query(state.filters);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [REMOVE]({ commit }, complex) {
      try {
        await ComplexService.delete(complex.id);
        commit(REMOVE_ITEM, complex);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [SAVE]({ commit }, complex) {
      try {
        await ComplexService.save(complex.id, complex);
        commit(SET_ITEM, complex);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    }
  },
  mutations: {
    [SET_ERROR](state, error) {
      state.error = error;
    },
    [SET_ITEM](state, complex) {
      const index = state.items.findIndex(item => item.id === complex.id);
      Vue.set(state.items, index, complex);
    },
    [SET_ITEMS](state, response) {
      state.error = null;
      state.items = response.data;
      Vue.set(state, 'pagination', response.meta);
    },
    [SET_FILTERS](state, filters) {
      Vue.set(state.filters, filters.key, filters.value);
    },
    [REMOVE_ITEM](state, complex) {
      const index = state.items.findIndex(item => item.id == complex.id);
      state.items.splice(index, 1);
    }
  }
};
